<form
  class="margin-top change-password"
  [formGroup]="changePasswordForm" 
  name="changePasswordForm"  
  [ngClass]="{ 'mt20': isAcmic, ' mt24': !isAcmic}"
  (ngSubmit)="changePasswordForm.valid && onConfirmChange()">
  <!-- <mapfre-alert [closeButton]="true"></mapfre-alert> -->
  <div class="row">
    <div class="col">
      <div *ngFor="let input of inputs" class="inputs">
        <mapfre-validation [input]="input" [form]="changePasswordForm"></mapfre-validation>
        <span class="help-block error-block" *ngIf="wrongPassword">
          {{ 'Wrong Password' | translate }}
        </span>
      </div>
    </div>
  </div>
  
  <!-- <div class="row" *ngIf="forgotPassword">
    <div class="col forgot-password">
      <mapfre-link
        (click)="prefillEmailParamater()"
        additionalClasses="switch-line-up blue-link underline margin-bottom mb24"
        >{{ 'FORGOT_PASS' | translate }}
      </mapfre-link>
    </div>
  </div> -->
  <div class="row margin-top mt16 text-center password-cnf-btn">
    <div class="col">
      <mapfre-button
        [ngClass]="{'custom_loader':loader}"
        additionalClasses="basic primary no-margin large-btn w-100"
        [disabledValue]="changePasswordForm.valid && !loader" 
        [inputType]="'submit'"
        [translateValue]="'CONFIRM_BUTTON' | translate"
      ></mapfre-button>
    </div>
  </div>
  <div class="row margin-top mt24 text-center change-password-btn-container">
    <div class="col">
    <ng-container *ngIf="whereInTheProcess === 'verify-password';else showBack">
      <mapfre-button
        additionalClasses="link-button small blue-link no-margin"
        (click)="onCancel()"
      >  {{ 'CANCEL' | translate }}
      </mapfre-button>
    </ng-container>
    <ng-template #showBack>
      <ng-container *ngIf="!isAcmic else backButton">
        <mapfre-button
        additionalClasses="link-button red-link small button-border-red change-password-back-ma"
        [backIcon]="'./assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle change-password-icon-left-ma'"
        [routerLink]="['/profile']"
        [showIconsCustom]="true"
  >  {{ 'BACK' | translate }}
     </mapfre-button>
      </ng-container>
       <ng-template #backButton>
        <mapfre-button
        additionalClasses="link-button blue-link small button-border-red change-password-back"
        [backIcon]="'./assets/img/images/change-password-icon-left.svg'"
        [iconClasses]="'align-middle change-password-icon-left'"
        [routerLink]="['/profile']"
        [showIconsCustom]="true"
  >  {{ 'BACK' | translate }}
     </mapfre-button>
      </ng-template>
       
    </ng-template>
    </div>
  </div>
</form>